// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-access-dialog {
  display: flex;
  flex-direction: column;
  width: 400px;
  min-height: 400px;
  margin: auto;
  background-color: #232323;
  padding: 10px;

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: center;

    button {
      width: 140px;
      align-self: center;
      justify-content: center;
      margin-top: 15px;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/fsAccess/drivers/nativeFS/FSAccessDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,aAAa;;EAEb;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,YAAY;MACZ,kBAAkB;MAClB,uBAAuB;MACvB,gBAAgB;IAClB;EACF;AACF","sourcesContent":[".fs-access-dialog {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  min-height: 400px;\n  margin: auto;\n  background-color: #232323;\n  padding: 10px;\n\n  .buttons-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n\n    button {\n      width: 140px;\n      align-self: center;\n      justify-content: center;\n      margin-top: 15px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
